import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getBannerSettingService = async (queryString) => {
  try {
    const url = `${apiUrl}/settings/banner${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const postBannerSettingService = async (value) => {
  try {
    const url = `${apiUrl}/settings/banner`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    const { data } = await httpService.post(url, value, config);
    return data;
  } catch (error) {
    throw error;
  }
};

const publishBanner = async (bannerId) => {
  try {
    const url = `${apiUrl}/settings/banner/publish/${bannerId}`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const revokeBanner = async (bannerId) => {
  try {
    const url = `${apiUrl}/settings/banner/revoke/${bannerId}`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const downloadBanner = async (bannerId) => {
  try {
    const url = `${apiUrl}/settings/banner/download/${bannerId}`;
    const data = await httpService.post(url, null, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteBanner = async (bannerId) => {
  try {
    const url = `${apiUrl}/settings/banner/delete/${bannerId}`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const editBanner = async (bannerId, value) => {
  try {
    const url = `${apiUrl}/settings/banner/update/${bannerId}`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const logoUpload = async (value) => {
  try {
    const url = `${apiUrl}/members/upload-admin-logo`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const logoFetch = async (value) => {
  try {
    const url = `${apiUrl}/members/logo/${value}`;
    const response = await httpService.post(
      url,
      {},
      {
        responseType: "arraybuffer",
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};
export {
  getBannerSettingService,
  postBannerSettingService,
  publishBanner,
  revokeBanner,
  downloadBanner,
  deleteBanner,
  editBanner,
  logoUpload,
  logoFetch,
};
